import React, { useState, useEffect } from 'react';
import { Outlet, useSearchParams, useLocation } from 'react-router-dom';

import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Modal from '../../Components/Modal/Modal';

// CC
import CCSignupForm from '../../Apps/CC/src/Components/SignUpForm/SignUpForm';
import CCSignInForm from '../../Apps/CC/src/Components/SignInForm/SignInForm';
import ResetPasswordCC from '../../Apps/CC/src/Components/ResetPassword/ResetPassword';

// HS
import HSSignInForm from '../../Apps/HS/src/Components/SignInForm/SignInForm';
import ResetPasswordHS from '../../Apps/HS/src/Components/ResetPassword/ResetPassword';

// TC
import TCSignupForm from '../../Apps/TC/src/Components/SignUpForm/SignUpForm';
import TCSignInForm from '../../Apps/TC/src/Components/SignInForm/SignInForm';
import ResetPasswordTC from '../../Apps/TC/src/Components/ResetPassword/ResetPassword';

import { remove, retrieve } from '../../Services/localStorageService';
import { clearAuth as clearCCAuth } from '../../Apps/CC/Config/Auth';
import { clearAuth as clearHSAuth } from '../../Apps/HS/Config/Auth';
import { clearAuth as clearTCAuth } from '../../Apps/TC/Config/Auth';
import { HeaderStyleProvider } from '../../Context/HeaderStyle/HeaderStyleContext';

function detectModalState(searchParams) {
    const token = searchParams.get('token');
    const appType = searchParams.get('appType');
    const openCCSignIn = searchParams.get('openCCSignIn');
    const openTCSignIn = searchParams.get('openTCSignIn');
    if (retrieve('showSignInModalCC') === 'true') { remove('showSignInModalCC'); return 'signinCC'; }
    if (retrieve('showSignInModalHS') === 'true') { remove('showSignInModalHS'); return 'signinHS'; }
    if (retrieve('showSignInModalTC') === 'true') { remove('showSignInModalTC'); return 'signinTC'; }
    if (token && appType === 'HS') return 'resetHS';
    if (token && appType === 'TC') return 'resetTC';
    if (token && appType === 'CC') return 'resetCC';
    if (openCCSignIn === 'true') return 'signinCC';
    if (openTCSignIn === 'true') return 'signinTC';
    return null;
}

function useLandingModal() {
    const [showModal, setShowModal] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const { pathname } = useLocation();
    const token = searchParams.get('token');

    useEffect(() => {
        if (pathname === '/') { clearCCAuth(); clearHSAuth(); clearTCAuth(); }
    }, [pathname]);

    useEffect(() => {
        const modal = detectModalState(searchParams);
        if (modal) setShowModal(modal);
    }, [searchParams]);

    const openSignup = (type = 'cc') => {
        if (type === 'cc') setShowModal('signupCC');
        else if (type === 'tc') setShowModal('signupTC');
    };

    const openSignin = (type = 'cc') => {
        if (type === 'cc') setShowModal('signinCC');
        else if (type === 'hs') setShowModal('signinHS');
        else if (type === 'tc') setShowModal('signinTC');
    };

    const handleClose = () => {
        setShowModal(null);
        ['token', 'openCCSignIn', 'openTCSignIn'].forEach(p => searchParams.delete(p));
        setSearchParams(searchParams);
    };

    return { showModal, setShowModal, token, openSignup, openSignin, handleClose };
}

const LandingLayout = () => {
    const { showModal, setShowModal, token, openSignup, openSignin, handleClose } = useLandingModal();

    return (
        <HeaderStyleProvider>
            <>
                <Header onSignUpClick={openSignup} onSignInClick={openSignin} />
                <Outlet context={{ openSignup, openSignin }} />
                <Footer />
                {showModal && (
                    <Modal onClose={handleClose}>
                        {showModal === 'signupCC' && <CCSignupForm onClose={handleClose} onOpenSignin={() => setShowModal('signinCC')} />}
                        {showModal === 'signinCC' && <CCSignInForm onClose={handleClose} onOpenSignup={() => setShowModal('signupCC')} />}
                        {showModal === 'resetCC' && <ResetPasswordCC onClose={handleClose} token={token} />}
                        {showModal === 'signinHS' && <HSSignInForm onClose={handleClose} />}
                        {showModal === 'resetHS' && <ResetPasswordHS onClose={handleClose} token={token} />}
                        {showModal === 'signupTC' && <TCSignupForm onClose={handleClose} onOpenSignin={() => setShowModal('signinTC')} />}
                        {showModal === 'signinTC' && <TCSignInForm onClose={handleClose} onOpenSignup={() => setShowModal('signupTC')} />}
                        {showModal === 'resetTC' && <ResetPasswordTC onClose={handleClose} token={token} />}
                    </Modal>
                )}
            </>
        </HeaderStyleProvider>
    );
};

export default LandingLayout;
